import styled from 'styled-components';
import { Card } from 'antd';

export const CardContainer = styled(Card)`
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};

  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    .ant-card-head-title {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.text};
      font-size: ${({ theme }) => theme.fontSizes.large};

      .card-title-left-total {
        color: ${({ theme }) => theme.colors.text};
        font-size: ${({ theme }) => theme.fontSizes.verySmall};
      }
    }
  }

  .ant-card-body {
    padding: 16px;
  }
`;
